import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { cloneDeep } from 'lodash';
import { WizardComponent, WizardStep, WizardStepComponent } from 'mbs-ui-kit';
import { RestoreIbbTypeModel, RestoreIbbTypeSteps } from 'wizards/models/restoreIBB/restore-ibb-type-model';
import { SelectTargetComputerDefaultValue } from 'wizards/models/select-target-computer-models';
import { RestoreAsDiskEnum } from 'wizards/models/type-data-models';
import { RemoteManagementWizardsService } from 'wizards/services/remote-management-wizards.service';
import { GenericRestoreStepsModule } from 'wizards/steps/only-restore-steps/generic-restore-steps/generic-restore-steps-module';
import { SelectTargetComputerStepComponent } from 'wizards/steps/only-restore-steps/select-target-computer-step/select-target-computer-step.component';
import { TypeDataStepComponent } from 'wizards/steps/only-restore-steps/type-data-step/type-data-step.component';

@Component({
  selector: 'mbs-ibb-restore-type-wizard',
  templateUrl: './ibb-restore-type-wizard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    GenericRestoreStepsModule,
    I18NextPipe,
    WizardStepComponent,
    WizardComponent,
    TypeDataStepComponent,
    SelectTargetComputerStepComponent
  ]
})
export class IbbRestoreTypeWizardComponent {
  public i18nPipe = inject(I18NextPipe);
  private mainService = inject(RemoteManagementWizardsService);

  public FormModel: RestoreIbbTypeModel = cloneDeep(RestoreIbbTypeSteps);

  public loading: WritableSignal<boolean> = signal(false);
  public currentStep: WritableSignal<WizardStep> = signal(null);
  public wizardFinish: WritableSignal<boolean> = signal(false);

  // The DR Server picked on the type step is the restore target, so the separate target computer step has nothing to add
  public get isDRServerRestore(): boolean {
    return this.FormModel?.typeDataStep?.restoreAs === RestoreAsDiskEnum.InstantRestoreToDRServer;
  }

  handleSave(): void {
    this.loading.set(true);

    // A computer picked on the hidden step before switching to DR Server would otherwise route the caller down the
    // restore-to-different-computer branch
    this.mainService.restoreIbbTypeModel = this.isDRServerRestore
      ? { ...this.FormModel, selectTargetComputerStep: SelectTargetComputerDefaultValue }
      : this.FormModel;
    this.wizardFinish.set(true);

    this.loading.set(false);
  }
}
